import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_MEM_23 } from "@/lib/programData";

export default function MarrakechLoop23Page() {
  return <ProgramTemplate program={PROGRAM_MEM_23} variant="mem" showJourneyChronology />;
}
